import React from 'react';
import { FaLockOpen, FaLock, FaExclamationTriangle } from 'react-icons/fa';
import { get } from 'lodash';
import {
  hidePinForm,
  showPinForm,
} from 'containers/PinForm/actions/pinForm.actions';
import { hidePlayerControls } from 'containers/Player/actions/controls/controls';
import { showMessage } from 'containers/Player/actions/alert/alerts';
import {
  LOCAL_STORAGE_USERHASH,
  GetRegion,
  PLAYER_SEGMENT,
} from 'constants.js';
import {
  hasPinChannelActive,
  hasPinConfigured,
  isAbletoBlock,
} from 'containers/EPG/selectors/pin.selectors';
import { hideEpg } from 'containers/Player/actions/optionButtons/epgButton.actions';
import { hideLiveOptionsMenu } from 'containers/Player/actions/optionButtons/liveOptionsButton.actions';
import {
  hidePlayerLoader,
  showPlayerLoader,
} from 'containers/Player/actions/player/player.actions';
import api from '../../../../services/api/microfwk';
import { browserHistory } from 'react-router';
import {
  BLOCK_CHANNEL_INIT,
  BLOCK_CHANNEL_SUCCESS,
  BLOCK_CHANNEL_ERROR,
  UNBLOCK_CHANNEL_INIT,
  UNBLOCK_CHANNEL_SUCCESS,
  UNBLOCK_CHANNEL_ERROR,
  GET_STATUS_CONTROL_PIN_INIT,
  GET_STATUS_CONTROL_PIN_SUCCESS,
  GET_STATUS_CONTROL_PIN_ERROR,
  ACTIVATE_CHANNEL_PIN_INIT,
  ACTIVATE_CHANNEL_PIN_SUCCESS,
  ACTIVATE_CHANNEL_PIN_ERROR,
  ACTIVATE_CONTROL_PIN_INIT,
  ACTIVATE_CONTROL_PIN_SUCCESS,
  ACTIVATE_CONTROL_PIN_ERROR,
  CHECK_CONTROL_PIN_INIT,
  CHECK_CONTROL_PIN_SUCCESS,
  CHECK_CONTROL_PIN_ERROR,
  REMIND_CONTROL_PIN_INIT,
  REMIND_CONTROL_PIN_SUCCESS,
  REMIND_CONTROL_PIN_ERROR,
  CLEAR_CHECK_CONTROL_PIN,
  UNLOCK_CONTENT_TEMPORARILY,
  CLEAR_TEMPORARILY_UNLOCKED_CONTENT,
  ACTIVATE_CHANNEL_PIN_CLEAR,
} from './constants';
import {
  pushEvent,
  EVENTS,
  CATEGORY,
  ACTIONS,
} from '../../../Player/utils/analytics';
import { redirect } from 'react-router-dom';
import { getIdChannelCurrenUrl } from '../../utils';

export const activateControlPin = params => dispatch => {
  const userhash = localStorage.getItem(LOCAL_STORAGE_USERHASH);
  dispatch({
    type: ACTIVATE_CONTROL_PIN_INIT,
  });
  return api
    .get('/services/user/activatecontrolpin', {
      params: {
        ...params,
        user_hash: userhash,
      },
    })
    .then(({ data }) => {
      if (data.status !== '0') {
        throw new Error(data.errors.error);
      }
      dispatch({
        type: ACTIVATE_CONTROL_PIN_SUCCESS,
        payload: data.response,
      });
    })
    .catch(error => {
      dispatch({
        type: ACTIVATE_CONTROL_PIN_ERROR,
        error,
      });
    });
};

export const blockChannels = ({ group_id, name, navigate }) => (
  dispatch,
  getState,
) => {
  const videoTagRef = document.getElementById('liveVideo');
  const state = getState();
  const pinConfigured = hasPinConfigured(state);
  const pinChannel = hasPinChannelActive(state);
  const isAbled = isAbletoBlock(state);
  const canPlay = state?.linealChannel?.data;
  const channelList = Object?.keys(canPlay || [])?.sort();
  const channelToBlock = state.Player.EpgChannels?.data?.find(
    channel => channel?.group_id === group_id,
  );
  const groupId = getIdChannelCurrenUrl();

  if (!pinConfigured) {
    // hay que implementar la lógica para generar un nuevo pin
    dispatch(
      showPinForm({
        type: 'DECIDE_NEW_PIN',
        title: state?.translations?.setupPin_confirmation_title_label || '',
        onSuccess: () => dispatch(blockChannels({ group_id, name, navigate })),
      }),
    );
    return null;
  }
  if (!pinChannel) {
    dispatch(
      showPinForm({
        type: 'SET_PIN_CHANNEL',
        title: state?.translations?.lockChannel_access_general_label || '',
        onSuccess: () => dispatch(blockChannels({ group_id, name, navigate })),
      }),
    );
    return null;
  }
  if (channelList.includes(group_id) && !isAbled) {
    dispatch(hidePinForm());
    dispatch(hideEpg());
    dispatch(hideLiveOptionsMenu());
    dispatch(
      showMessage(
        <>
          <FaExclamationTriangle color="#cbb200" />
          <span style={{ minWidth: '0.3rem' }} />
          {`${state?.translations?.notBlockAllChannels_alert_title_label ||
            ''} | ${state?.translations
            ?.notBlockAllChannels_alert_description_label || ''}
          `}
        </>,
      ),
    );
    return true;
  }
  dispatch({
    type: BLOCK_CHANNEL_INIT,
  });
  const userhash = localStorage.getItem(LOCAL_STORAGE_USERHASH);
  return api
    .get('/services/user/controlpin/channels/add', {
      params: {
        user_hash: userhash,
        group_id,
      },
    })
    .then(async ({ data }) => {
      if (data.status !== '0') {
        throw new Error(data?.errors?.code);
      }
      dispatch(hidePinForm());
      dispatch(getStatusControlPin());
      dispatch(hideEpg());
      dispatch(hideLiveOptionsMenu());
      dispatch(hidePlayerControls);
      const alertMessage =
        state?.translations?.lockChannel_alert_title_label?.replace(
          '@canal',
          `${channelToBlock?.name || ''} ${channelToBlock?.number || ''}`,
        ) || `${channelToBlock?.name || ''} ${channelToBlock?.number || ''}`;
      if (groupId === channelToBlock?.group?.common?.id) {
        const prevDisplay = videoTagRef?.style?.display;
        const showAlert = () => {
          videoTagRef.style.display = prevDisplay;
          dispatch(
            showMessage(
              <>
                <FaLock />
                <span style={{ minWidth: '0.3rem' }} />
                {`${
                  typeof state?.translations?.lockChannel_alert_title_label !==
                  'undefined'
                    ? alertMessage
                    : 'lockChannel_alert_title_label'
                } | ${state?.translations
                  ?.lockChannel_alert_description_label || ''}
                `}
              </>,
            ),
          );
        };
        videoTagRef.pause();
        videoTagRef.style.display = 'none';
        await dispatch(
          changeToChannel({ direction: 1, skipLocked: true, navigate }),
        );
        showAlert();
        dispatch(clearActivateChannelPin());
      } else {
        dispatch(
          showMessage(
            <>
              <FaLock />
              <span style={{ minWidth: '0.3rem' }} />
              {`${
                typeof state?.translations?.lockChannel_alert_title_label !==
                'undefined'
                  ? alertMessage
                  : 'lockChannel_alert_title_label'
              } | ${state?.translations?.lockChannel_alert_description_label}
            `}
            </>,
          ),
        );
      }
      dispatch({
        type: BLOCK_CHANNEL_SUCCESS,
      });
    })
    .catch(error => {
      dispatch(showMessage(error?.message));
      dispatch({
        type: BLOCK_CHANNEL_ERROR,
      });
    });
};

export const unblockChannel = ({ group_id, pin }) => (dispatch, getState) => {
  const state = getState();
  const channelToUnblock = state?.Player?.EpgChannels?.data?.find(
    channel => channel.group_id === group_id,
  );
  if (!pin) {
    dispatch(
      showPinForm({
        type: 'UNBLOCK_CHANNEL',
        title: state?.translations?.lockChannel_access_subtitle_label || '',
        onSuccess: enteredPin => {
          dispatch(unblockChannel({ group_id, pin: enteredPin }));
        },
      }),
    );
    return null;
  }
  dispatch({
    type: UNBLOCK_CHANNEL_INIT,
  });
  const userhash = localStorage.getItem(LOCAL_STORAGE_USERHASH);
  return api
    .get('/services/user/controlpin/channels/delete', {
      params: {
        user_hash: userhash,
        group_id,
      },
    })
    .then(({ data }) => {
      if (data.status !== '0') {
        throw new Error(data?.errors?.code);
      }
      dispatch(hidePinForm());
      dispatch(getStatusControlPin());
      dispatch(hideEpg());
      dispatch(hideLiveOptionsMenu());
      const alertMessage =
        state?.translations?.unlockChannel_alert_title_label?.replace(
          '@canal',
          `${channelToUnblock?.group?.common?.title} ${
            channelToUnblock?.group?.common?.channel_number
          }`,
        ) ||
        `${channelToUnblock?.group?.common?.title} ${
          channelToUnblock?.group?.common?.channel_number
        }`;
      dispatch(
        showMessage(
          <>
            <FaLockOpen />
            <span style={{ minWidth: '0.3rem' }} />
            {`${
              typeof state?.translations?.unlockChannel_alert_title_label !==
              'undefined'
                ? alertMessage
                : 'unlockChannel_alert_title_label'
            }`}
          </>,
        ),
      );
      dispatch({
        type: UNBLOCK_CHANNEL_SUCCESS,
      });
    })
    .catch(error => {
      dispatch(showMessage(error?.message));
      dispatch({
        type: UNBLOCK_CHANNEL_ERROR,
      });
    });
};

export const checkIfChannelIsBlocked = ({ group_id, onSuccess, rating }) => (
  dispatch,
  getState,
) => {
  const state = getState();
  return Promise.resolve(state.cvEpg.channelBlocker.statusControlPin)
    .then(scp => {
      if (!scp.success) {
        return api.get('/services/user/statuscontrolpin').then(({ data }) => {
          if (data.status !== '0') {
            throw new Error(data?.errors?.error);
          }
          return data?.response;
        });
      }
      return scp.data;
    })
    .then(data => {
      const blockedChannels = data?.pin_channel?.info || [];
      if (group_id && blockedChannels.indexOf(String(group_id)) >= 0) {
        dispatch(hidePlayerLoader());
        dispatch(
          showPinForm({
            type: 'UNBLOCK_CHANNEL',
            title:
              state?.translations?.lockChannel_access_subtitleWatch_label || '',
            onSuccess: () => {
              dispatch(hidePinForm());
              dispatch(unlockContentTemporarily(group_id));
              onSuccess();
            },
          }),
        );
      } else if (rating && rating >= data?.pin_parental?.info?.value) {
        dispatch(hidePlayerLoader());
        dispatch(
          showPinForm({
            type: 'UNBLOCK_CHANNEL',
            title:
              state?.translations?.lockChannel_access_instruction_label || '',
            onSuccess: () => {
              dispatch(hidePinForm());
              onSuccess();
            },
          }),
        );
      } else {
        onSuccess();
      }
    })
    .catch(error => {
      console.error('error', error);
    });
};

export const checkIfProtectPaymentIsActive = ({ onSuccess }) => (
  dispatch,
  getState,
) => {
  const state = getState();
  return Promise.resolve(state?.cvEpg?.channelBlocker?.statusControlPin)
    .then(scp => {
      if (!scp.success) {
        return api.get('/services/user/statuscontrolpin').then(({ data }) => {
          if (data.status !== '0') {
            throw new Error(data?.errors?.error);
          }
          return data?.response;
        });
      }
      return scp?.data;
    })
    .then(data => {
      if (data?.pin_purchase?.status === 1) {
        dispatch(hidePlayerLoader());
        dispatch(
          showPinForm({
            type: 'UNBLOCK_CHANNEL',
            title:
              state?.translations?.lockPIN_access_subtitlePayment_label || '',
            onSuccess: () => {
              dispatch(hidePinForm());
              onSuccess();
            },
          }),
        );
      } else {
        onSuccess();
      }
    });
};

export const getStatusControlPin = () => dispatch => {
  dispatch({
    type: GET_STATUS_CONTROL_PIN_INIT,
  });
  return api
    .get('/services/user/statuscontrolpin')
    .then(({ data }) => {
      if (data.status !== '0') {
        throw new Error(data?.errors?.error);
      }
      dispatch({
        type: GET_STATUS_CONTROL_PIN_SUCCESS,
        payload: data.response,
      });
    })
    .catch(error => {
      dispatch({
        type: GET_STATUS_CONTROL_PIN_ERROR,
        error,
      });
    });
};

export const activateChannelPin = pin => (dispatch, getState) => {
  dispatch({
    type: ACTIVATE_CHANNEL_PIN_INIT,
  });
  const currentPinStatus = getState()?.cvEpg?.channelBlocker?.statusControlPin
    .data;
  const newProfileisKids =
    getState()?.profilesManager?.configProfileForm?.is_kids || false;
  return api
    .get('/services/user/modifycontrolpin', {
      params: {
        status_purchase_pin: newProfileisKids
          ? '1'
          : currentPinStatus?.pin_purchase?.status,
        status_parental_pin: newProfileisKids
          ? '1'
          : currentPinStatus?.pin_parental?.status,
        accesss_parental_code: newProfileisKids
          ? '20'
          : currentPinStatus?.pin_parental?.info?.value,
        status_channel_pin: 1,
        pin,
      },
    })
    .then(({ data }) => {
      if (data.status !== '0') {
        throw new Error(data.errors.error);
      }
      dispatch({
        type: ACTIVATE_CHANNEL_PIN_SUCCESS,
        payload: data.response,
      });
      // we need to update the statusControlPin with the new status por pin_channel since the modification succeeded
      dispatch({
        type: GET_STATUS_CONTROL_PIN_SUCCESS,
        payload: Object.assign(
          {},
          getState().cvEpg.channelBlocker.statusControlPin.data,
          {
            pin_channel: { status: 1 },
          },
        ),
      });
    })
    .catch(error => {
      dispatch({
        type: ACTIVATE_CHANNEL_PIN_ERROR,
        error,
      });
    });
};

export const clearActivateChannelPin = () => ({
  type: ACTIVATE_CHANNEL_PIN_CLEAR,
});

export const checkControlPin = pin => (dispatch, getState) => {
  const state = getState();
  const { user: { user_id = '' } = {} } = state;
  dispatch({
    type: CHECK_CONTROL_PIN_INIT,
  });
  return api
    .get('/services/user/checkcontrolpin', {
      params: {
        controlPIN: pin,
        userId: user_id,
      },
    })
    .then(({ data }) => {
      if (data.status !== 0) {
        throw new Error(data?.errors);
      }
      dispatch({
        type: CHECK_CONTROL_PIN_SUCCESS,
        payload: data?.response,
      });
    })
    .catch(error => {
      dispatch({
        type: CHECK_CONTROL_PIN_ERROR,
        error,
      });
    });
};

export const clearCheckControlPin = () => dispatch => {
  dispatch({
    type: CLEAR_CHECK_CONTROL_PIN,
  });
};

export const getRemindControlPin = () => (dispatch, getState) => {
  const state = getState();
  const { user: { userhash = '' } = {} } = state;
  dispatch({
    type: REMIND_CONTROL_PIN_INIT,
  });
  return api
    .get('/services/user/remindcontrolpin', {
      params: {
        user_hash: userhash,
      },
    })
    .then(({ data }) => {
      // eslint-disable-next-line eqeqeq
      if (data.status != 0) {
        throw new Error(data.errors?.error?.join('; '));
      }
      dispatch({
        type: REMIND_CONTROL_PIN_SUCCESS,
        payload: data?.response,
      });
    })
    .catch(error => {
      dispatch({
        type: REMIND_CONTROL_PIN_ERROR,
        error,
      });
    });
};

export const unlockContentTemporarily = id => ({
  type: UNLOCK_CONTENT_TEMPORARILY,
  payload: id,
});

export const clearTemporarilyUnlockedContent = () => ({
  type: CLEAR_TEMPORARILY_UNLOCKED_CONTENT,
});

export const changeToChannel = ({
  direction,
  skipLocked = false,
  navigate,
}) => async (dispatch, getState) => {
  const state = getState();

  if (
    skipLocked &&
    state?.cvEpg?.channelBlocker?.statusControlPin?.inProgress
  ) {
    return new Promise(resolve => {
      setTimeout(async () => {
        await dispatch(changeToChannel({ direction, skipLocked, navigate }));
        resolve();
      }, 2000);
    });
  }
  const groupId = getIdChannelCurrenUrl();
  const canPlay = state?.linealChannel?.data;
  const epgChannels = state.Player?.EpgChannels?.data;

  const channelsGroupIdList = epgChannels?.map(channel => channel?.group_id);
  const channelsAble = channelsGroupIdList?.filter(
    group_id => canPlay?.[group_id]?.live?.canPlay === 1,
  );
  pushEvent(
    EVENTS.TV,
    CATEGORY.TV_PLAYER,
    ACTIONS.CLICK,
    direction === -1 ? 'canal anterior' : 'canal siguiente',
  );

  const currentIndex = channelsAble?.indexOf(groupId);
  const nextIndex =
    (currentIndex + direction + channelsAble?.length) % channelsAble?.length;

  if (currentIndex !== nextIndex) {
    dispatch(showPlayerLoader());
    dispatch(goToPlayerWithId(channelsAble?.[nextIndex], navigate));
  }
  return null;
};

export const goToPlayerWithId = (id, navigate) => dispatch => {
  dispatch(
    checkIfChannelIsBlocked({
      group_id: id,
      onSuccess: () => {
        navigate(`/${GetRegion()}${PLAYER_SEGMENT}${id}`);
      },
    }),
  );
};
